import { Box, Typography } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

const badgeStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 0.5,
  background: 'linear-gradient(135deg, #6a1b9a, #c62828)',
  borderRadius: '10px',
  px: 1,
} as const;

const labelStyles = {
  fontSize: '0.625rem',
  fontWeight: 700,
  color: '#fff',
  letterSpacing: '0.3px',
} as const;

export const TorqueIQBadge = () => (
  <Box sx={badgeStyles}>
    <AutoAwesomeIcon sx={{ fontSize: '0.75rem', color: '#fff' }} />
    <Typography component="span" sx={labelStyles}>
      TorqueIQ
    </Typography>
  </Box>
);
